import { t } from "@/i18n-js/instance";
import { TRIGGER_RESOURCE_TYPE } from "../../../constants";
import type { EventOption } from "../types";
import { PaywallResource } from "./shared/PaywallResource";
import { WhichPaywallSelector } from "./shared/WhichPaywallSelector";

export const memberWorkflowsSubscriptionCanceled: Readonly<EventOption> = {
  label: t(
    "workflows_v2.events.community_member_workflows_subscription_canceled.title",
  ),
  value: "community_member_workflows_subscription_canceled",
  group: t("settings.workflows.form.event_groups.paywalls"),
  description: t(
    "workflows_v2.events.community_member_workflows_subscription_canceled.description",
  ),
  resource: TRIGGER_RESOURCE_TYPE.PAYWALL,
  formComponent: WhichPaywallSelector,
  viewComponent: PaywallResource,
  icon: "paywall",
};
